import { useContext } from 'react';
import FlagsContext from '../context/FlagContext';

export function useFlags() {
  return useContext(FlagsContext);
}
